import { useState } from "react";
import { useTranslation } from "react-i18next";
import { postData, putData } from "../../Services/apiService";
import { useAlert } from "../../Provider/Alert/AlertContext";

export function useUserForm({ idClient, user = null, onClose }) {
    const { t } = useTranslation(); // Translation hook
    const { addAlert } = useAlert(); // Alert context

    // Função para validar o formulário
    const [userForm, setUserForm] = useState({
        name: "",
        email: "",
        password: "",
        confirm_password: "",
        id_profile: "",
        is_active: true,
        id_client: null,
    });
    const [isEditing, setIsEditing] = useState(false);
    const [btnDisable, setBtnDisable] = useState(false);

    // Efeito colateral para atualizar o formulário quando o usuário muda
    // Se o usuário existir, preenche o formulário com os dados do usuário
    // Se não, reseta o formulário para os valores iniciais
    useState(() => {
        if (user?.id) {
            setUserForm({
                id: user.id,
                name: user.name || "",
                email: user.email || "",
                id_profile: user.profile.id || null,
                password: "",
                confirm_password: "",
                is_active: user.is_active !== undefined ? user.is_active : true,
                id_client: user.id_client || null,
            });
            setIsEditing(true);
        } else {
            setUserForm({
                name: "",
                email: "",
                password: "",
                confirm_password: "",
                id_profile: "",
                is_active: true,
                id_client: null,
            });
            setIsEditing(false);
        } // eslint-disable-next-line
    }, [user]);

    // Função para enviar o formulário
    const handleFormSubmit = async () => {
        // desbilita os botoes enqunto processa do cadastro
        setBtnDisable(true);

        // Ajusta o id_profile para ser um inteiro
        userForm.id_profile = parseInt(userForm.id_profile);

        // Montagem da url
        let url = "";
        if (idClient) {
            url += `/client/${idClient}`;
            userForm.id_client = idClient;
        }
        url += "/user";

        try {
            // Envia requisicao para o servidor
            let saveUser = null;
            if (userForm.id) {
                saveUser = await putData(url, userForm.id, userForm);
            } else {
                saveUser = await postData(url, userForm);
            }

            // Se o servidor retornar erro, exibe mensagem de erro
            if (saveUser.status !== 200) {
                addAlert(
                    "danger",
                    t("users.form.alert.error.title"),
                    t("users.form.alert.error.message")
                );
                setBtnDisable(false);
                return;
            }

            // Espera a resposta do servidor
            if (saveUser.status === 200) {
                addAlert(
                    "success",
                    t("users.form.alert.success.title"),
                    t("users.form.alert.success.message")
                );
                onClose();
                setBtnDisable(false);
                return;
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleCancel = () => {
        setUserForm({});
        setIsEditing(false);
        onClose();
    };

    return {
        userForm,
        setUserForm,
        isEditing,
        btnDisable,
        handleFormSubmit,
        handleCancel,
    };
}
